import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

import InputDate from "../../atoms/InputDate/InputDate";
import { QuestionProps } from "../../../types/components/molecules/questionProps";

const Third = ({ formData, setFormData, onValidationChange }: QuestionProps) => {
  const { t } = useTranslation();

  useEffect(() => {
    onValidationChange?.(!!formData.birth_date);
  }, [formData.birth_date, onValidationChange]);

  return (
    <InputDate
      label={t("animalInfo:QUESTION_THREE.BIRTHDATE")}
      value={formData.birth_date ? dayjs(formData.birth_date) : null}
      onChange={(value) =>
        setFormData({
          ...formData,
          birth_date: value?.toISOString(),
        })
      }
    />
  );
};

export default Third;
